<template>
    <div v-show="userPermissionsFilter.viewusers" :class="[companyClass, canScroll]">
        <div class="page-table column mb-20" :class="{ 'flex': !isMobile, 'overflow': isMobile }">
            <h2 class="text-white">Company Directors</h2>
            <div class="table-responsive">
                <table class="table" id="directorsTable" style="color:white;">
                    <thead>
                        <tr>
                            <th>Full Name</th>
                            <th>Company</th>
                            <th>Country</th>
                            <th>Document Type</th>
                            <th>Identification Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in userdata" :key="item.ID">
                            <td>{{ item.firstName }} {{ item.middleName }} {{ item.lastName }}</td>
                            <td>{{ item.companyName }}</td>
                            <td>{{ item.countryName }}</td>
                            <td>{{ item.documentTypeID }}</td>
                            <td>{{ item.iDdocumentNumber }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Full Name</th>
                            <th>Company</th>
                            <th>Country</th>
                            <th>Document Type</th>
                            <th>Identification Number</th>
                        </tr>
                    </tfoot>
                </table>
            </div>

        </div>
    </div>
</template>


<script>
import moment from 'moment'

import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"

import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import $ from 'jquery';
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/';

export default {
    name: 'Directors',
    data: function () {
        return {
            userdata: [],
        }
    },
    computed: {
        readOnlyMode() {
            return !this.userPermissionsFilter.addusers && !this.userPermissionsFilter.editusers;
        }
    },
    methods: {
        openDialog(row) {
            this.userdata = row;
            this.dialogFormVisible = true
        },

        async fetchAllDirectors() {
            this.pageLoading = true;
            this.userdata = await this.GetDirectorsList();
            this.pageLoading = false;
        },

        initDt() {
            $('#directorsTable').DataTable({
                dom: 'Blfrtip',
                "aaSorting": [],
                buttons: [
                    'print'
                ],
                initComplete: function () {
                    var api = this.api();
                },

            });
        }
    },

    async mounted() {
        await this.fetchAllDirectors()
        this.initDt()
    },

    created() {
    },
    mixins: [PermissionsMixins]
}

</script>

<style>
table.dataTable tbody tr {
    background-color: #191d24;
}

table.dataTable {
    margin-left: 0px;
    text-align: left;
}

.avatar-box {
    background: #3773e2;
    margin-bottom: 50px;
    position: relative;
}

.avatar-box img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    position: relative;
    bottom: -50px;
    display: block;
    margin: 0 auto;
    background: white;
    border: 2px solid #3773e2;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.dataTables_filter label,
.dataTables_wrapper .dataTables_filter input {
    color: white !important;
}

.dataTables_wrapper .dataTables_filter input ::placeholder,
.dataTables_wrapper .dataTables_filter input ::-ms-input-placeholder {
    color: white !important;
}

.dataTables_wrapper .dataTables_paginate a.paginate_button {
    color: white !important;
}
</style>